import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PspAccountValues } from '../../types';
import { pspApi } from '../services';

export interface BankAndPspInfoAccountFormState {
  formValues?: PspAccountValues;
}

const initialState: BankAndPspInfoAccountFormState = {};

export const bankAndPspInfoAccountFormSlice = createSlice({
  name: 'bankAndPspInfoAccountForm',
  initialState,
  reducers: {
    clearBankAndPspInfoAccountFormState: (state) => {
      state.formValues = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      pspApi.endpoints.getPspAccount.matchFulfilled,
      (state, action: PayloadAction<{ data: PspAccountValues }>) => {
        state.formValues = {
          categoryId: action.payload.data.categoryId,
          currencyType: action.payload.data.currencyType,
          currencyId: action.payload.data.currencies?.map(
            (item) => item.id,
          ) as string[],
          pspPartnerId: action.payload.data.pspPartnerId,
          pspPrimaryAccountId: action.payload.data.pspPrimaryAccountId,
          description: action.payload.data.description,
          visibleToClient: action.payload.data.visibleToClient,
          realNumberOrIban: action.payload.data.realNumberOrIban,
          accountOfCorrespondentWithIntermediaryBank:
            action?.payload?.data?.accountOfCorrespondentWithIntermediaryBank,
          intermediaryBankName: action?.payload?.data?.intermediaryBankName,
          intermediaryBankSwift: action?.payload?.data?.intermediaryBankSwift,
          caspId: action?.payload?.data?.caspId,
          excludeFromTopUpIfExternalAccountAvailable:
            action?.payload?.data?.excludeFromTopUpIfExternalAccountAvailable,
          useOwnBankDetails: action?.payload?.data?.useOwnBankDetails,
          bankName: action?.payload?.data?.bankName,
          bankLegalName: action?.payload?.data?.bankLegalName,
          bankCountryId: action?.payload?.data?.bankCountryId,
          bankAddress: action?.payload?.data?.bankAddress,
          bankSortCode: action?.payload?.data?.bankSortCode,
          bankSwift: action?.payload?.data?.bankSwift,
          bankAba: action.payload?.data?.bankAba,
        };
      },
    );
  },
});

export const { clearBankAndPspInfoAccountFormState } =
  bankAndPspInfoAccountFormSlice.actions;

export default bankAndPspInfoAccountFormSlice.reducer;
